export default function useText() {
  const splitCamelCaseString = (input: string) => {
    return input.replace(/([a-z])([A-Z])/g, '$1 $2')
  }

  const normalize = (text: string) => {
    if (text !== null) {
      return text
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
    } else {
      return ''
    }
  }
  const pad = (num: number | string, size: number) => {
    num = num.toString()
    while (num.length < size) {
      num = `0${num}`
    }
    return num
  }

  const snakeToCamel = (snake: string): string => {
    return snake.replace(/(_\w)/g, (m) => m[1].toUpperCase())
  }

  const camelToSnake = (obj: any): any => {
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }

    if (Array.isArray(obj)) {
      return obj.map(camelToSnake)
    }

    const snakeObj: { [key: string]: any } = {}
    for (const [key, value] of Object.entries(obj)) {
      const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
      snakeObj[snakeKey] = camelToSnake(value)
    }
    return snakeObj
  }

  return { normalize, splitCamelCaseString, pad, snakeToCamel, camelToSnake }
}
